// @flow

import axios from 'axios'
import type { Axios } from 'axios'

export type AuthRequest = {
  setResponse: (status: number, response: Object) => void,
} & Axios

export type NetError = {
  response: {
    data: {
      message: string,
    },
  },
}

const wrapAxios = (mockObject: any): AuthRequest => mockObject
const authenticatedRequest = wrapAxios(axios.create())

// Add authentication token in the requests
authenticatedRequest.interceptors.request.use(
  config => {
    let authToken = 'Bearer ' + (localStorage.getItem('auth-token') || '')
    config.headers = { ...config.headers, Authorization: authToken }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// Update the token into localstorage on responses
authenticatedRequest.interceptors.response.use(
  response => {
    let newToken = ''
    if (response && response.headers && response.headers['auth-token']) {
      newToken = response.headers['auth-token']
    }
    localStorage.setItem('auth-token', newToken)
    return response
  },
  err => {
    if (err.response.status === 401) {
      localStorage.removeItem('auth-token')
    }
    return Promise.reject(err)
  }
)

export default authenticatedRequest



// WEBPACK FOOTER //
// ./src/store/authenticated-request.js